import script from "./AdminDefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdminDefaultLayout.vue?vue&type=style&index=0&id=41517e87&lang=css"

const __exports__ = script;

export default __exports__